import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select } from "antd";

import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
import { getPracticalLinkList } from "../../actions/publish";

const { RangePicker } = DatePicker;
const { Option } = Select;

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
    },
    select: {
      width: "100%",
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
    },
  };
};

class PracticalLink extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      Region: "",
      Department: "",
      WebLink: "",
      Content: "",
      UpdateTime: []
    },
    labelObj: {
      KeyWord: '关键词',
      Region: '区域',
      Department: '部门',
      WebLink: '链接',
      Content: '内容',
      UpdateTime: '更新时间'
    },
    sortObj: {},
    page: {
      PageNo: 1,
      PageSize: 10,
    },
    total: 0,
    scrollObj: {
      x: 1820,
      y: 600,
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return (
          "当前已筛选出【" +
          this.state.paginationObj.total +
          "】条，总数据量【" +
          this.state.paginationObj.allTotal +
          "】条"
        );
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
  };

  componentDidMount() {
  
    let form = {
      ...this.state.defaultForm
    }
    this.setState({
      form,
    })
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        Region: "",
        Department: "",
        WebLink: "",
        Content: "",
        UpdateTime: []
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        if (key == 'UpdateTime') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let UpdateTime = this.state.form.UpdateTime
    let param = {
      ...this.state.page,
      ...this.state.form,
      Time_KS: UpdateTime && UpdateTime.length > 0 ? UpdateTime[0].format("YYYY-MM-DD") : null,
      Time_JS: UpdateTime && UpdateTime.length > 0 ? UpdateTime[1].format("YYYY-MM-DD") : null,
    }
    delete(param.UpdateTime)
    
    getPracticalLinkList(param).then((res) => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.DataNumber;
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber;
        this.setState(
          {
            data: res.DataList.map((v) => {
              v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany;
              return v;
            }),
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  };

  getColumns = () => {
    let classes = this.props.classes;

    let columns = [
      {
        title: "区域",
        dataIndex: "Region",
        key: "Region",
        width: 140,
      },
      {
        title: "部门",
        dataIndex: "Department",
        width: 180,
        key: "Department",
      },
      {
        title: "链接",
        dataIndex: "WebLink",
        key: "WebLink",
        width: 180,
      },
      {
        title: "内容",
        dataIndex: "Content",
        width: 400,
        key: "Content",
      },
      {
        title: "更新时间",
        dataIndex: "UpdateTime",
        key: "UpdateTime",
        width: 160,
      },
    ];

    this.setState({
      columns: columns,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };


  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.PageNo &&
      pageSize == this.state.page.PageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          PageNo: page,
          PageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">区域</div>
              <Input  value={this.state.form.Region}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Region')} 
                placeholder="请输入区域"/>
            </div>
            <div className="form-item">
              <div className="form-label">部门</div>
              <Input  value={this.state.form.Department}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Department')} 
                placeholder="请输入部门"/>
            </div>
            <div className="form-item">
              <div className="form-label">链接</div>
              <Input  value={this.state.form.WebLink}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'WebLink')} 
                placeholder="请输入链接"/>
            </div>
            <div className="form-item">
              <div className="form-label">内容</div>
              <Input  value={this.state.form.Content}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Content')} 
                placeholder="请输入内容"/>
            </div>
            <div className="form-item">
              <div className="form-label">更新时间</div>
              <div className="form-input">
                <RangePicker
                  allowClear
                  value={this.state.form.UpdateTime}
                  onChange={(value) => this.onChangeForm(value, 'UpdateTime')}
                />
              </div>
            </div>
          </div>
  
          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>
        
        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">实用链接</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                dataSource={this.state.data}
                onChange={this.handleChange}
                pagination={this.state.paginationObj}
                bordered
              />
            </Grid>
          </div>
        </div>

      </div>
    );
  }
}

export default withStyles(styles)(withRouter(PracticalLink));
